export const allWorkspaceSeatTypes = [
    "Full",
    "Builder",
    /**
     * Can be also referred to as a "Viewer seat"
     */
    "None",
];
